'use strict';

const React = require('react');
const PropTypes = require('prop-types');
const tracking = require('dibs-tracking');
const ContextComponent = require('../../../global/components/ContextComponent');
const Modal = require('../../../global/components/Modal');
const { noop } = require('../../../global/mixins/commonjs/basicUtils');
const { SwipeCarousel } = require('../../../global/components/carousel');
const PinchZoomComponent = require('../../../global/components/PinchZoomComponent');
const CloseIcon = require('dibs-vg/dist/react/close');
const carouselHelpers = require('../../helpers/carouselHelpers.es');

/**
 * Modal containing mobile pinch/zoom carousel on the PDP.
 *
 * TODO: There is too much functionality here. The combination of swipe carousel and pinch/zoom children can probably be
 * extracted into a re-usable component so that the rules about disabling/enabling swiping based on the zoom state can
 * be encapsulated.
 */
class MobileZoomModal extends ContextComponent {
    constructor(props) {
        super(props);

        this.state = {
            index: props.startingIndex,
        };

        this._eventFired = false;

        this._closeModal = this._closeModal.bind(this);
        this._enableSwipe = this._enableSwipe.bind(this);
        this._disableSwipe = this._disableSwipe.bind(this);
        this._updateCurrent = this._updateCurrent.bind(this);
        this._handleZoomIn = this._handleZoomIn.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        this.setState({ index: nextProps.startingIndex });
        if (this.refs && this.refs.carousel) {
            this.refs.carousel.setPage(nextProps.startingIndex);
        }
    }

    _enableSwipe() {
        this.refs.carousel.enableSwipe();
    }

    _disableSwipe() {
        this.refs.carousel.disableSwipe();
    }

    _handleZoomIn() {
        // Prevent swiping if a child element is zoomed in.
        this._disableSwipe();

        if (!this._eventFired) {
            this._trackZoom();
            // Disable event tracking until we see a new image.
            this._eventFired = true;
        }
    }

    _trackZoom() {
        const { owner } = this.props;
        const category = carouselHelpers.getCarouselCategory(owner);
        tracking.trackEvent({
            category,
            action: 'mobile image zoom',
            label: `${this.state.index + 1}/${this.props.images.length}`,
        });
    }

    _closeModal() {
        // Unzoom the current child when the modal closes.
        this.refs[`image-${this.state.index}`].reset();
        this._enableSwipe();
        this.props.onRequestClose();
        this._eventFired = false;
    }

    _updateCurrent(index) {
        // Allow firing tracking event again since we are on a new image.
        if (index !== this.state.index) {
            this._eventFired = false;
        }

        this.props.onIndexChange(index);
        this.setState({ index });
    }

    _getStyle() {
        const { style } = this.props;
        return Object.assign(
            {},
            {
                content: {
                    top: 0,
                    bottom: 0,
                    right: 0,
                    left: 0,
                    padding: 0,
                },
            },
            style
        );
    }

    _getChildren() {
        const currentIndex = this.state.index;

        return this.props.images.map((image, i) => {
            return (
                <PinchZoomComponent
                    ref={`image-${i}`}
                    enabled={currentIndex === i}
                    onZoomIn={this._handleZoomIn}
                    onZoomOut={this._enableSwipe}
                    key={i}
                    className="mobile-zoom-carousel-image-wrapper"
                >
                    <div
                        className="mobile-zoom-carousel-image"
                        style={{ backgroundImage: `url(${image.large.src})` }}
                    />
                </PinchZoomComponent>
            );
        });
    }

    render() {
        return (
            <Modal {...this.props} onRequestClose={this._closeModal} style={this._getStyle()}>
                <div className="mobile-zoom-modal-close-wrapper">
                    <span
                        onClick={this._closeModal}
                        className="mobile-zoom-modal-close"
                        title="Close"
                    >
                        <CloseIcon className="mobile-zoom-modal-close-icon" />
                    </span>
                </div>
                <div className="mobile-zoom-modal-content-wrapper">
                    <div className="mobile-zoom-modal-content-body">
                        <SwipeCarousel
                            ref="carousel"
                            classNames={{
                                wrapper: 'mobile-zoom-carousel-wrapper',
                                list: 'mobile-zoom-carousel-list',
                                item: 'mobile-zoom-carousel-item',
                            }}
                            onPageChange={this._updateCurrent}
                            startingPage={this.state.index}
                        >
                            {this._getChildren()}
                        </SwipeCarousel>
                    </div>
                    <div className="mobile-zoom-modal-content-footer">
                        <div className="mobile-zoom-modal-indicator-wrapper">
                            <span className="mobile-zoom-modal-indicator">{`${this.state.index +
                                1} of ${this.props.images.length} images`}</span>
                        </div>
                    </div>
                </div>
            </Modal>
        );
    }
}

MobileZoomModal.propTypes = {
    owner: PropTypes.string,
    onRequestClose: PropTypes.func,
    style: PropTypes.object,
    images: PropTypes.array,
    startingIndex: PropTypes.number,
    onIndexChange: PropTypes.func,
};

MobileZoomModal.defaultProps = {
    onRequestClose: noop,
    style: {},
    images: [],
    startingIndex: 0,
    onIndexChange: noop,
};

module.exports = MobileZoomModal;



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/Carousel/MobileZoomModal.jsx